module.exports = __webpack_public_path__ + "static/media/home_background.7fc09740.png";